import { render, staticRenderFns } from "./lab-order-in-task.vue?vue&type=template&id=31dd1eaa"
import script from "./lab-order-in-task.vue?vue&type=script&lang=js"
export * from "./lab-order-in-task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports